import { render } from "./SocialProof.vue?vue&type=template&id=8aed120a&scoped=true"
import script from "./SocialProof.vue?vue&type=script&lang=js"
export * from "./SocialProof.vue?vue&type=script&lang=js"

import "./SocialProof.vue?vue&type=style&index=0&id=8aed120a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aed120a"]])

export default __exports__